import Base from '@studiometa/js-toolkit';

/**
 * ShowMore
 */
export default class ShowMore extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'ShowMore',
    };
  }

  /**
   * Mounted
   */
  mounted() {
    this.reduce();
  }

  /**
   * Expand Ref
   * @param {DOMElement} ref Reference element
   */
  expandRef(ref) {
    if (ref === undefined) return;
    ref.setAttribute('aria-hidden', 'false');
    ref.classList.remove('hidden');
  }

  /**
   * Reduce Ref
   * @param {DOMElement} ref Reference element
   */
  reduceRef(ref) {
    if (ref === undefined) return;
    ref.setAttribute('aria-hidden', 'true');
    ref.classList.add('hidden');
  }

  /**
   * Expand
   */
  expand() {
    this.isLong = true;
    this.expandRef(this.$refs.long);
    this.reduceRef(this.$refs.short);

    if (this.$refs.more) {
      this.$refs.more.classList.add('hidden');
      this.$refs.less.classList.remove('hidden');
    }
  }

  /**
   * Reduce
   */
  reduce() {
    this.isLong = false;
    this.expandRef(this.$refs.short);
    this.reduceRef(this.$refs.long);

    if (this.$refs.more) {
      this.$refs.more.classList.remove('hidden');
      this.$refs.less.classList.add('hidden');
    }
  }

  /**
   * Toggle
   */
  toggle() {
    if (this.isLong) {
      this.reduce();
    } else {
      this.expand();
    }
  }

  /**
   * On Toggle Click
   */
  onToggleClick() {
    this.toggle();
  }
}
